import { render } from "./registration-signin.vue?vue&type=template&id=f87ea522&scoped=true"
import script from "./registration-signin.vue?vue&type=script&lang=js"
export * from "./registration-signin.vue?vue&type=script&lang=js"

import "./registration-signin.vue?vue&type=style&index=0&id=f87ea522&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87ea522"]])

export default __exports__